@if (filteredPrintData$ | async; as filteredData) {
  @if (_projectReference) {
    <section class="hidden print:block page-container">
      <img id="vw-arrow" class="vw-arrow" src="../../../assets/images/vwarrow.svg"/>
      <header class="page-header-first">
        <app-photo class="page-header-first__photo" [photo]="_projectReference.primaryPhoto"></app-photo>
        <div class="page-header-first__photo-company-logo">
          <app-print-logo-company [logoSrc]="_projectReference.companyLogo"></app-print-logo-company>
        </div>
        <!-- First overlay makes the image BW -->
        <div class="page-header-first__photo-overlay page-header-first__photo-overlay--bw"></div>
        <!-- Second overlay has blue BG with opacity -->
        <div class="page-header-first__photo-overlay page-header-first__photo-overlay--blue"></div>
        <!-- Third overlay has gradient -->
        <div class="page-header-first__photo-overlay">
          <h1 class="page-header-first__title">
            {{ _projectReference.commercialProjectName || _projectReference.name }}
          </h1>
          <h2 class="page-header-first__subtitle">{{_projectReference.city}}</h2>
        </div>
      </header>
      <header class="page-header">
        <h1>{{ _projectReference.commercialProjectName || _projectReference.name }}</h1>
        <h2>{{_projectReference.street}}, {{_projectReference.city}}</h2>
      </header>
      <div class="page-footer"></div>
      <div class="page-footer-logo">
        <app-print-logo-company [logoSrc]="_projectReference.companyLogo"></app-print-logo-company>
      </div>
      <table>
        <thead>
          <tr>
            <td>
              <div class="page-header-spacer">&nbsp;</div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <p class="page__description" [innerHTML]="_projectReference.description | nl2br"></p>
            <div class="page__project-info">
              <div class="page__project-info__left">
                @if (filteredData.teamMembers && filteredData.teamMembers.length > 0) {
                  <div class="page__project-info__team">
                    <h3>Projectteam</h3>
                    @for (teamMember of filteredData.teamMembers; track teamMember) {
                      <div>
                        <h4>{{ teamMember.name }}</h4>
                        {{ teamMember.role | teamMemberRoleTranslate}}
                      </div>
                    }
                  </div>
                }
                @if (filteredData.relations && filteredData.relations.length > 0) {
                  <div class="page__project-info__partners">
                    <h3>Partners</h3>
                    @for (relation of filteredData.relations; track relation) {
                      <div>
                        <h4>{{ relation.role.value }}</h4>
                        <p>{{ relation.companyName }}</p>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="page__project-info__general">
                <h3>Projectinformatie</h3>
                <div class="page__project-info__general__grid">
                  <h4>Opdrachtgever</h4>
                  <span>{{_projectReference.properties.clientName || '-'}}</span>
                  <h4>Projectfase</h4>
                  <span>{{_projectReference.properties.phase || '-'}}</span>
                  <h4>Start bouw</h4>
                  <span>{{(_projectReference.properties.start|date:"MMMM yyyy") || '-'}}</span>
                  <h4>Opleverdatum</h4>
                  <span>{{(_projectReference.properties.end|date:"MMMM yyyy") || '-'}}</span>
                  <h4>Locatie</h4>
                  <span>
                    @if (_projectReference.street && _projectReference.houseNumber) {
                      {{ _projectReference.street }} {{ _projectReference.houseNumber }} <br>
                    }
                    @if (_projectReference.postCode) {
                      {{ _projectReference.postCode }} <br>
                    }
                    @if (_projectReference.city) {
                      {{ _projectReference.city }}
                    }
                  </span>
                  @if (filteredData.attributes; as attributes) {
                    @if (attributes.type) {
                      <h4>{{'type' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.type}}</span>
                    }
                    @if (attributes.coreDataProject) {
                      <h4>{{'coreDataProject' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.coreDataProject}}</span>
                    }
                    @if (attributes.buildingClassification && attributes.buildingClassification.length) {
                      <h4>{{'buildingClassification' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.buildingClassification}}</span>
                    }
                    @if (attributes.buildingSubClassification && attributes.buildingSubClassification.length) {
                      <h4>{{'buildingSubClassification' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.buildingSubClassification}}</span>
                    }
                    @if (attributes.vwConcept) {
                      <h4>{{'vwConcept' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.vwConcept}}</span>
                    }
                    @if (attributes.sustainabilityClass) {
                      <h4>{{'sustainabilityClass' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.sustainabilityClass}}</span>
                    }
                    @if (attributes.urbanDensity) {
                      <h4>{{attributes.urbanDensity.title}}</h4>
                      <span>{{getSelectedValue(attributes.urbanDensity)?.title}}</span>
                    }
                    @if (attributes.surfaceBVO) {
                      <h4>{{'surfaceBVO' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.surfaceBVO | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.surfaceVVO) {
                      <h4>{{'surfaceVVO' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.surfaceVVO | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.surfaceFacade) {
                      <h4>{{'surfaceFacade' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.surfaceFacade | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.locationSize) {
                      <h4>{{'locationSize' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.locationSize | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.buildingLayersAboveGround) {
                      <h4>{{'buildingLayersAboveGround' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.buildingLayersAboveGround | formatAttributeValue}}</span>
                    }
                    @if (attributes.buildingLayersUnderGround) {
                      <h4>{{'buildingLayersUnderGround' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.buildingLayersUnderGround | formatAttributeValue}}</span>
                    }
                    @if (attributes.demolitionSize) {
                      <h4>{{'demolitionSize' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.demolitionSize | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.remediateSize) {
                      <h4>{{'remediateSize' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.remediateSize | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.readyForConstructionSize) {
                      <h4>{{'readyForConstructionSize' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.readyForConstructionSize | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.readyToLiveSize) {
                      <h4>{{'readyToLiveSize' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.readyToLiveSize | formatAttributeValue:'':'m²'}}</span>
                    }
                    @if (attributes.totalBuildingObjects) {
                      <h4>{{'totalBuildingObjects' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.totalBuildingObjects | formatAttributeValue}}</span>
                    }
                    @if (attributes.energyLabel) {
                      <h4>{{attributes.energyLabel.title}}</h4>
                      <span>{{getSelectedValue(attributes.energyLabel)?.title}}</span>
                    }
                    @if (attributes.riskManagement) {
                      <h4>{{attributes.riskManagement.title}}</h4>
                      <span>{{getSelectedValue(attributes.riskManagement)?.title}}</span>
                    }
                    @if (attributes.keyFeatures) {
                      <h4>{{'keyFeatures' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.keyFeatures | formatAttributeValue}}</span>
                    }
                    @if (attributes.maintanceContractYears) {
                      <h4>{{'maintanceContractYears' | attributeKeyTranslate}}</h4>
                      <span>{{attributes.maintanceContractYears | formatAttributeValue}}</span>
                    }
                  }
                </div>
              </div>
            </div>
          </tr>
          @if (filteredData.photos.length) {
            <tr class="page-photos">
              <td>
                <div class="page__photos">
                  <div class="page__photos__grid" [style.grid-template-areas]="filteredData.photoLayout">
                    @for (photo of filteredData.photos; track photo; let i = $index) {
                      <app-photo [photo]="photo"
                        [style.grid-area]="photoGridAreas[i]">
                      </app-photo>
                    }
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div class="page-footer-spacer">&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>
    </section>
  }
}
